import { render, staticRenderFns } from "./ProgressArrows.vue?vue&type=template&id=5645ac82&scoped=true&"
import script from "./ProgressArrows.vue?vue&type=script&lang=ts&"
export * from "./ProgressArrows.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressArrows.vue?vue&type=style&index=0&id=5645ac82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645ac82",
  null
  
)

export default component.exports